/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import CustomerReview from '../modules/customer-review'
import DoctorIframe from '../modules/iframe-schedule/doctor'
import BranchIframe from '../modules/iframe-schedule/branch'
import { App } from '../App'
import MemberCardLineOa from '../modules/apps/patient/treatment/MemberCardLineOa'
import TeethChartLineOa from '../modules/apps/patient/treatment/TeethChartLineOa'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const { currentUser } = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='iframe/doctor/:slug' element={<DoctorIframe />} />
          <Route path='iframe/branch/:code' element={<BranchIframe />} />
          <Route path='line-oa/teeth-chart/:lineUid' element={<TeethChartLineOa />} />
          <Route path='line-oa/member-card/:id' element={<MemberCardLineOa />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route path='customer-review' element={<CustomerReview />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='customer-review' element={<CustomerReview />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
